<div class="column" [class.column-sm]="column.static">
  <div class="content">
    <cc-user-avatar [user]="column.user"></cc-user-avatar>
    <div class="sm-ml-2">{{ column.user?.fullName }}</div>
  </div>
</div>
